import { Link } from 'react-router-dom'
import { XCircle } from 'lucide-react'
import Header from '../components/Header'

const CancelPage: React.FC = () => {
  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #0f172a 100%)'}}>
      <Header />
      
      <main className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <XCircle className="h-16 w-16 mx-auto mb-4" style={{color: '#ef4444'}} />
            <h1 className="text-3xl font-bold mb-2" style={{color: '#f9fafb'}}>
              Payment Canceled
            </h1>
            <p style={{color: '#d1d5db'}}>
              Your payment was canceled. No charges have been made to your account.
            </p>
          </div>

          <div className="space-y-4">
            <Link
              to="/pricing"
              className="btn btn-primary w-full"
            >
              Try Again
            </Link>
            
            <Link
              to="/dashboard"
              className="btn btn-outline w-full"
            >
              Go to Dashboard
            </Link>
          </div>

          <div className="mt-8 text-sm" style={{color: '#9ca3af'}}>
            <p>
              If you have any questions or need assistance, please contact our support team.
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default CancelPage
